<script setup>
  //import { FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
  import { ref, onMounted } from 'vue';
  import {defaultContext, setMapContext, waiter} from "@/context/global.js";
  import {MapContext} from "@/engine/mapContext.js";
  import {elog} from "@/engine/helpers/logging.js";
  import {UITemplates} from "@/engine/UITemplates.js";

  const initError = ref(null);

  onMounted(()=> {
    // wait for template resources get ready and creates the main map context
    waiter.add( function () {
      if (UITemplates.ready) {
        let mapContext;
        try {
          mapContext = new MapContext(defaultContext)
          elog("INFO", "mapContext created");
          setMapContext(mapContext);
          mapContext.run();
        } catch (error) {
          elog("ERROR", "mapContext doesn't created due to an error", error);
          initError.value  = error.message;
        }
        return true;
      }
      return false;
    }, 5000, function () {
      initError.value  = "can't init mapContext due to the templates are still not loaded"
      elog("ERROR", initError.value)
    })
  });
</script>

<template>
  <template v-if="initError">
    <p class="error-message">
      Something went wrong during application initialization.
      The service is currently undergoing maintenance and is temporarily unavailable.
      We are actively working to resolve the issue.
      If you see this message for an extended period, please email us at <a href="mailto:info@maphub.online">info@maphub.online</a>
    </p>
  </template>
  <div id="map"></div>
</template>

<style scoped>

</style>
